import { render, staticRenderFns } from "./Contrast.vue?vue&type=template&id=58bf9a8f&"
import script from "./Contrast.vue?vue&type=script&lang=js&"
export * from "./Contrast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports